module.exports = "//static.hsappstatic.net/LearningCenterUI/static-1.32682/images/playlist-assignments-empty-state.svg"